export const AFFILIATE_MARKER_QUERY_KEYS = [
    "btag",
    "bTag",
    "Btag",
    "BTag",
    "BTAG",
];

export const DEFAULT_AFFILIATE_MARKER_COOKIES_EXPIRES_DAYS: number = 14;